export class DataEmision {
    medioPago: number = 15;
    cot_id: number = 0;
    id_asenta_cpcon: 1;
    neg_id: number = 0;
    paq: number = 0;
    socio: number = 0;
    usr: number = 0;
    usuario: string = '';
    password: string = '';
    cia: number = 0;
    cve: string = '';
    mod: string = "";
    cp: string = '';
    col: string = '';
    poblacion: string = '';
    estado: number = 0;
    sexo: string = '';
    tipo_persona: string = '';
    vig_de: string = '';
    vig_a: string = '';
    forpag: string = '1';
    valor: number = 0.0;
    edad: number = 18;
    pd: number = 0;
    mcpio: number = 0;
    apoderado: string = '';
    rfc_apoderado: string = '';
    folio: string = '0';
    uso: string = '';
    servicio: string = '';
    //mon: number = 0;
    vehiculo: Vehiculo = new Vehiculo();
    contratante: Contratante = new Contratante();
    conductor: Conductor = new Conductor();
    beneficiarios: Array<Beneficiarios> = new Array<Beneficiarios>();
    /**Fecha en al que se expidió la factura */
    fec_factura?:string;
    /**Número de factura a cotizar */
    numFactura?:string;
}

export class Vehiculo {
    serie: string = '';
    placas: string = '';
    motor: string = '';
    color: string = '';
    edo_cir: number = 0;
}

export class Contratante {
    tipo_persona: string = 'F';
    rfc: string = '';
    nombres: string = '';
    ap_pat: string = '';
    ap_mat: string = '';
    sexo: string = 'M';
    sexoTexto: string = '';
    edoCivil: string = 'S';
    fec_nac: string = '';
    fec_nac_str: string = '';
    noempleado: string = '';
    direccion: DireccionContratante = new DireccionContratante();
    moral: ContratanteMoral = new ContratanteMoral();
    telefonos: Array<TelefonosContratante> = new Array<TelefonosContratante>();
    celular: Array<TelefonosContratante> = new Array<TelefonosContratante>();
    correos: Array<CorreosContratante> = new Array<CorreosContratante>();
}

export class DireccionContratante {
    calle: string = '';
    no_ext: string = '';
    no_int: string = '';
    col: string = '';
    delegacion_mcpio: string = '';
    estado: string = '';
    cp: string = '';
    pais_mcpio: string = 'MEXICO';
    c_mcpio: string = '0';
    c_col: string = '0';
    tipoDir: number = 1;
    ciudad: string = '';
    munId: string = '';
    ciudadID: number = 0;
    municipioID: number = 0;
    coloniaID: number = 0;
}

export class ContratanteMoral {
    razon_social: string = '';
    giro: string = '';
    regimen: boolean = true;
    tipoSociedad: number = 1;
}

export class TelefonosContratante {
    cve_lada: string = '';
    cve_lada_nac: string = '';
    num_tel: string = '';
    tipo: number = 1; //1 - Celular, 2 - Teléfono
}

export class CorreosContratante {
    correo: string = '';
}

export class Conductor {
    fec_nac: string = '';
    edad_cond_hab: number = 0;
    sexo: string = 'M';
    rfc: string = 'xxxx010101';
    ap_mat: string = '';
    ap_pat: string = '';
    edo_civil: string = '';
    nombres: string = '';
    tipo_persona: string = 'F';
    fec_nac_str: string = '';
    mismo_conductor: boolean = false;
    ref: string = '';
    cod_promocion?: string;
}

export class Beneficiarios {
    ban_irrevocable: string = '';
    nombres: string = '';
    ap_pat: string = '';
    ap_mat: string = '';
    clave: string = '';
    pct_beneficio: string = '';
    tipo_persona: string = '';
}

export class Bancos {
    c1?: string = ""; /**Clave banco */
    c2?: string = ""; /**Nombre banco */
    c3?: Array<Plazos> = new Array<Plazos>(); /**Plazos */
}

export class Plazos {
    c1?: string = '0'; /**Plazo */
    c2?: string = ""; /**Descripción de plazo */
}

export class PolizaComplemento {
    polizaID: number = 0;
    agenteClaveID: number = 0;
    ramoID: number = 0;
    subRamoID: number = 0;
    PaqueteID: number = 0;
    consecutivo: number = 4;
    noPoliza: string = "";
    concepto: string = "";
    prima: number = 0.00;
    derecho: number = 0.00;
    recargo: number = 0.00;
    iva: number = 0.00;
    total: number = 0.00;
    pdf: number = 0;
    ref: string = "";
}

export class PelEmision {
    tipo: string = ''; /**tipo cuenta, credito, debito, etc*/
    numero: string = ''; /**Número de tarjeta */
    fecCorte: string = ''; /**FecCorte de cobro */
    banco: string = ''; /**Clave banco */
    cvn: string = ''; /**Código tarjeta */
    fec_vcto: string = ''; /**fecha vencimiento */
    nombre: string = ''; /**Nombre tarjetahabiente */
    ap_mat: string = ''; /**Apellido Paterno tarjetahabiente */
    ap_pat: string = ''; /**Apellido Materno tarjetahabiente */
    email: string = ''; /**Correo */
    empresa: string = ''; /**Visa, MasterCard o AMEX */
    direccion: string = ''; /**Direccion */
    rfc: string = ''; /**RFC */
    modalidad: string = ''; /**Modalidad de meses sin intereses */
    pagoTipo:string = '';  /**Sirve para señalar del lado de la emisión si es TC o Domiciliación */
}